import { Icon } from "@minervaproject/fds";
import { forwardRef } from "react";

import { IconPropsType } from "shared/types";

export const WarningIcon = forwardRef<HTMLElement, IconPropsType>((props, ref) => (
  <Icon {...props} ref={ref}>
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g transform="translate(-419.000000, -462.000000)" fill={props?.color || "#FFFFFF"}>
          <g transform="translate(30.000000, 31.000000)">
            <g transform="translate(220.000000, 420.000000)">
              <path d="M184.78056,25.3087426 L177.951282,11.6976246 C177.689689,11.2325311 177.344845,11 177.000002,11 C176.655158,11 176.310314,11.2325311 176.04869,11.6976246 L169.219412,25.3087426 C168.696193,26.2389296 169.141287,26.9999917 170.208536,26.9999917 L183.791467,26.9999917 C184.858685,26.9999917 185.303841,26.2389296 184.78056,25.3087426 L184.78056,25.3087426 Z M177.000002,24.9999927 C176.447721,24.9999927 176.000002,24.5522742 176.000002,23.9999933 C176.000002,23.447681 176.447721,22.9999938 177.000002,22.9999938 C177.552314,22.9999938 178.000001,23.447681 178.000001,23.9999933 C178.000001,24.5522742 177.552314,24.9999927 177.000002,24.9999927 L177.000002,24.9999927 Z M177.687501,21.9999943 L176.312502,21.9999943 L176.000002,17.9999964 C176.000002,17.4477154 176.447721,16.9999969 177.000002,16.9999969 C177.552283,16.9999969 178.000001,17.4477154 178.000001,17.9999964 L177.687501,21.9999943 L177.687501,21.9999943 Z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </Icon>
));
